import type { QuickLinkProps } from '@/components';

export const allQuickLinks: QuickLinkProps[] = [
  { label: 'Staff Portal', to: 'https://staffportal.curtin.edu.au/', showIcon: true },
  { label: 'Oasis', to: 'https://oasis.curtin.edu.au/', showIcon: true },
  { label: 'Academic Calendar', to: 'https://www.curtin.edu.au/students/essentials/academic-calendar/' },
  { label: 'How to apply', to: 'https://www.curtin.edu.au/study/applying/domestic/how-to-apply/' },
  { label: 'Scholarships', to: 'http://scholarships.curtin.edu.au/' },
  { label: 'Research', to: 'https://research.curtin.edu.au/' },
];

export const coursesDomesticQuickLinks: QuickLinkProps[] = [
  { label: 'How to apply', to: 'https://www.curtin.edu.au/study/applying/domestic/how-to-apply/' },
  { label: 'On-campus accomodation', to: 'https://www.curtin.edu.au/study/campus-life/accommodation/' },
  { label: 'Scholarship opportunities', to: 'https://www.curtin.edu.au/study/scholarships/find-a-scholarship/' },
  { label: 'Fees and charges', to: 'https://www.curtin.edu.au/study/fees-financial-assistance/fees-charges/' },
  { label: 'Academic calendar', to: 'https://www.curtin.edu.au/students/essentials/academic-calendar/' },
];

export const courseInternationalQuickLinks: QuickLinkProps[] = [
  { label: 'How to apply', to: 'https://www.curtin.edu.au/study/applying/international/applying-via-curtin/' },
  { label: 'Scholarships', to: 'https://www.curtin.edu.au/study/scholarships/international-scholarships/' },
  { label: 'English requirements', to: 'https://www.curtin.edu.au/study/applying/english-language-requirements/' },
  { label: 'Find an agent', to: 'https://www.curtin.edu.au/study/applying/international/apply-via-an-agent/' },
  {
    label: 'Meet us in your country',
    to: 'https://www.curtin.edu.au/study/international-students/meet-us-in-your-country/',
  },
];

export const eventsQuickLinks: QuickLinkProps[] = [{ label: 'Events', to: 'https://www.curtin.edu.au/events/' }];

export const newsQuickLinks: QuickLinkProps[] = [
  { label: 'News home', to: 'https://www.curtin.edu.au/news/' },
  { label: 'Research news', to: 'https://research.curtin.edu.au/news/' },
  { label: 'Podcasts', to: 'https://www.curtin.edu.au/news/podcasts/' },
];

export const peopleQuickLinks: QuickLinkProps[] = [
  { label: 'Staff portal', to: 'https://staffportal.curtin.edu.au/', showIcon: true },
];

export const researchQuickLinks: QuickLinkProps[] = [
  { label: 'Research', to: 'https://research.curtin.edu.au/', showIcon: true },
];
